/* Poker Chip Kings set builder. Data comes from the JSON block written by sections/pck-set-builder.liquid. */
(function () {
  var app = document.querySelector('[data-pck-builder]');
  var dataEl = document.querySelector('[data-pck-builder-data]');
  if (!app || !dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { app.innerHTML = '<p>Sorry, the set builder could not load. Please refresh the page.</p>'; return; }
  if (!D.styles || !D.styles.length) { app.innerHTML = '<p>No chip styles are set up for the set builder yet.</p>'; return; }

  var SIZES = [
    { n: 300, note: 'Up to about 6 players' },
    { n: 500, note: '8 to 10 players' },
    { n: 600, note: '10 players plus rebuys' },
    { n: 1000, note: 'Tournaments or two tables' }
  ];
  var SIZE_PHRASE = { 300: 'up to about 6 players', 500: '8 to 10 players', 600: '10 players plus rebuys', 1000: 'two full tables' };
  var FILTERS = [
    { id: 'all', label: 'All styles', test: function () { return true; } },
    { id: 'composite', label: 'Clay composite', test: function (s) { return s.cat === 'composite'; } },
    { id: 'clay', label: '100% clay', test: function (s) { return s.cat === 'clay'; } },
    { id: 'ceramic', label: 'Ceramic', test: function (s) { return s.cat === 'ceramic'; } },
    { id: 'nondenom', label: 'Non-denominated', test: function (s) { return !s.denom; } }
  ];
  var MOBILE = window.matchMedia('(max-width: 749px)');

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var v = (Math.round(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (D.moneyFormat || '${{amount}}').replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]*>/g, '');
  }
  function commas(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function findStyle(k) {
    for (var i = 0; i < D.styles.length; i++) if (D.styles[i].k === k) return D.styles[i];
    return null;
  }
  function casesFor(sty, size) {
    var list = D.cases.filter(function (c) { return sty.is43 ? c.is43 : (!c.is43 && c.size === size); });
    list.push({ id: 'none', name: 'Chips only', rows: 0, per: 0, price: 0, meta: 'Add a case later, or use trays', metaShort: 'Add a case later', img: '' });
    return list;
  }
  function defaultCase(sty, size) {
    var list = casesFor(sty, size);
    for (var i = 0; i < list.length; i++) if (list[i].id !== 'none' && !list[i].out) return list[i].id;
    return 'none';
  }

  // Suggested mixes (counts are in chips, always multiples of 25).
  function mix(sty, game, size) {
    var avail = sty.vals.filter(function (v) { return !v.out; });
    var counts = {};
    if (!sty.denom) {
      var pref = ['White', 'Red', 'Blue', 'Green', 'Black', 'Yellow', 'Purple', 'Pink', 'Orange', 'Gray', 'Brown', 'Dark Blue', 'Light Blue'];
      var sorted = avail.slice().sort(function (a, b) {
        var ia = pref.indexOf(a.label), ib = pref.indexOf(b.label);
        return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
      });
      var tn = { 300: [100, 75, 75, 50], 500: [100, 100, 100, 100, 100], 600: [100, 100, 100, 100, 100, 100], 1000: [200, 150, 150, 150, 100, 100, 75, 75] }[size];
      tn.forEach(function (n, j) { if (sorted[j]) counts[sorted[j].id] = n; });
      return counts;
    }
    if (game === 'cash') {
      var tc = { 300: [100, 75, 75, 50], 500: [150, 150, 100, 50, 50], 600: [150, 150, 150, 100, 50], 1000: [300, 300, 200, 100, 100] }[size];
      tc.forEach(function (n, j) { if (avail[j]) counts[avail[j].id] = n; });
      return counts;
    }
    var targets = [25, 100, 500, 1000, 5000];
    var tt = { 300: [100, 100, 50, 50], 500: [150, 150, 100, 75, 25], 600: [150, 150, 125, 125, 50], 1000: [250, 250, 225, 225, 50] }[size];
    var used = {};
    tt.forEach(function (n, j) {
      var best = null, bestD = 1e9;
      avail.forEach(function (v) {
        if (used[v.id] || !(v.amt > 0)) return;
        var d = Math.abs(Math.log(v.amt) - Math.log(targets[j]));
        if (d < bestD) { bestD = d; best = v; }
      });
      if (best) { used[best.id] = true; counts[best.id] = n; }
    });
    return counts;
  }

  // Initial state, from ?style=<handle>&size=<n>&case=<handle>. No style is chosen unless the link names one
  // (each chip page's set link, the 43mm case page and old set addresses do); the shopper picks it in step 1.
  var params = new URLSearchParams(location.search);
  var startStyle = findStyle(params.get('style')) || findStyle(params.get('style') + '-poker-chips');
  var startSize = +params.get('size');
  if ([300, 500, 600, 1000].indexOf(startSize) < 0) startSize = 500;
  var linkCase = params.get('case');
  var extras0 = {};
  D.extras.forEach(function (e) { extras0[e.k] = 0; });
  function startCaseFor(sty, size) {
    var id = defaultCase(sty, size);
    casesFor(sty, size).forEach(function (c) { if (linkCase && c.handle === linkCase && !c.out) id = c.id; });
    return id;
  }
  var state = {
    styleKey: startStyle ? startStyle.k : null, filter: 'all', game: 'cash', size: startSize,
    counts: startStyle ? mix(startStyle, 'cash', startSize) : {}, caseId: startStyle ? startCaseFor(startStyle, startSize) : 'none',
    extras: extras0, busy: false, error: ''
  };

  function set(patch) {
    for (var k in patch) state[k] = patch[k];
    render();
  }

  function stepper(key, count, opts) {
    return '<div class="pck-stepper ' + (opts.cls || '') + '">' +
      '<button type="button" class="pck-stepper__btn" data-act="' + opts.act + '" data-id="' + esc(opts.id) + '" data-d="-1" data-key="' + key + '-m"' + (opts.noRemove ? ' disabled' : '') + ' aria-label="' + esc(opts.removeLabel) + '">−</button>' +
      '<output class="pck-stepper__count" aria-live="polite">' + esc(opts.countText != null ? opts.countText : count) + '</output>' +
      '<button type="button" class="pck-stepper__btn" data-act="' + opts.act + '" data-id="' + esc(opts.id) + '" data-d="1" data-key="' + key + '-p"' + (opts.noAdd ? ' disabled' : '') + ' aria-label="' + esc(opts.addLabel) + '">+</button>' +
      '</div>';
  }
  function stepHead(n, title, extra) {
    return '<div class="pck-step-head"><span class="pck-eyebrow">Step ' + n + ' of 4</span>' + (extra || '<h2 class="pck-step-head__h2">' + esc(title) + '</h2>') + '</div>';
  }

  // Step 1 (chip style), shared by the empty state and the full builder.
  function styleStep(activeFilter, sty, note) {
    var h = '<section class="pck-bstep" aria-labelledby="bs1">' + stepHead(1, 'Chip style').replace('<h2 ', '<h2 id="bs1" ');
    if (note) h += '<p class="pck-step-note">' + esc(note) + '</p>';
    h += '<div class="pck-filters pck-filters--builder" role="group" aria-label="Filter styles">';
    FILTERS.forEach(function (f) {
      h += '<button type="button" class="pck-filter" data-act="filter" data-id="' + f.id + '" data-key="f-' + f.id + '" aria-pressed="' + (f.id === activeFilter.id) + '">' + esc(f.label) + '</button>';
    });
    h += '</div><div class="pck-choice-grid pck-choice-grid--styles" role="radiogroup" aria-label="Chip style">';
    D.styles.filter(activeFilter.test).forEach(function (s) {
      var on = !!sty && s.k === sty.k;
      h += '<button type="button" role="radio" aria-checked="' + on + '" class="pck-choice pck-choice--style" data-act="style" data-id="' + esc(s.k) + '" data-key="s-' + esc(s.k) + '">' +
        '<img src="' + esc(s.img) + '" alt="" width="52" height="52" loading="lazy">' +
        '<span class="pck-choice__text"><span class="pck-choice__title">' + esc(s.name) + '</span>' +
        '<span class="pck-choice__meta pck-num"><span class="pck-desktop-only">' + esc(s.w + ' ' + s.mat) + '</span><span class="pck-mobile-only">' + esc(s.w) + '</span> · ' + money(s.price) + '</span></span></button>';
    });
    h += '</div></section>';
    return h;
  }

  // Before a style is picked: step 1 only, and an empty summary on computers.
  function renderEmpty(activeFilter) {
    var h = '<div class="pck-builder__layout"><div class="pck-builder__steps">';
    h += styleStep(activeFilter, null, 'Pick a style to see its values, set sizes and cases.');
    h += '</div>';
    h += '<aside class="pck-bsum" aria-label="Your set"><div class="pck-bsum__titles"><span class="pck-eyebrow">Your set</span>' +
      '<span class="pck-bsum__name">Choose a chip style</span><span class="pck-bsum__sub">Your values, case and set total show here.</span></div>' +
      '<button type="button" class="pck-btn pck-btn--primary pck-btn--block pck-bsum__btn" data-act="add" data-key="add" disabled>Choose a chip style</button></aside></div>';
    paint(h);
  }

  function paint(h) {
    var focusKey = document.activeElement && app.contains(document.activeElement) ? document.activeElement.getAttribute('data-key') : null;
    app.innerHTML = h;
    if (focusKey) {
      var el = app.querySelector('[data-key="' + focusKey + '"]');
      if (el && !el.disabled) el.focus({ preventScroll: true });
    }
  }

  function render() {
    var sty = findStyle(state.styleKey);
    var activeFilter = FILTERS.filter(function (f) { return f.id === state.filter; })[0] || FILTERS[0];
    if (!sty) { renderEmpty(activeFilter); return; }
    var sizeObj = SIZES.filter(function (s) { return s.n === state.size; })[0];
    var valuesWord = sty.denom ? 'values' : 'colors';

    // Values
    var chips = 0, valuesUsed = 0, chipCents = 0, anyOut = false;
    sty.vals.forEach(function (v) {
      var n = state.counts[v.id] || 0;
      if (v.out) anyOut = true;
      chips += n; if (n > 0) valuesUsed++;
      chipCents += (n / 25) * v.price;
    });
    var rolls = chips / 25;

    // Case
    var caseList = casesFor(sty, state.size);
    var cs = caseList.filter(function (c) { return c.id === state.caseId; })[0] || caseList[0];
    var capacity = cs.rows * cs.per;
    var over = cs.rows > 0 && chips > capacity;
    var room = capacity - chips;
    var hasBigger = caseList.some(function (c) { return c.rows > 0 && !c.out && c.rows * c.per >= chips; });
    var overRolls = Math.ceil((chips - capacity) / 25);
    var fillNote = over ? ('Remove ' + overRolls + (overRolls === 1 ? ' roll' : ' rolls') + (hasBigger ? ' or pick a bigger case' : ' to fit this case'))
      : (room === 0 ? 'Full' : 'Room for ' + (room / 25) + (room === 25 ? ' more roll' : ' more rolls'));

    // Extras
    var extrasCents = 0, extraLines = [];
    D.extras.forEach(function (e) {
      var q = state.extras[e.k] || 0;
      if (q > 0) { extrasCents += q * e.price; extraLines.push({ label: q + ' ' + (q === 1 ? e.one : e.many), cents: q * e.price }); }
    });
    var total = chipCents + cs.price + extrasCents;
    var items = valuesUsed + (cs.id === 'none' ? 0 : 1) + extraLines.length;

    var h = '';
    h += '<div class="pck-builder__layout"><div class="pck-builder__steps">';

    // Step 1
    h += styleStep(activeFilter, sty, '');

    // Step 2
    h += '<section class="pck-bstep" aria-labelledby="bs2">' + stepHead(2, 'How do you play?').replace('<h2 ', '<h2 id="bs2" ');
    if (sty.denom) {
      h += '<div class="pck-choice-grid pck-choice-grid--games" role="radiogroup" aria-label="Game type">';
      [['cash', 'Cash game', 'Lower values for blinds and small bets'], ['tour', 'Tournament', 'Big starting stacks, $25 and up']].forEach(function (g) {
        var on = state.game === g[0];
        h += '<button type="button" role="radio" aria-checked="' + on + '" class="pck-choice pck-choice--stack" data-act="game" data-id="' + g[0] + '" data-key="g-' + g[0] + '"><span class="pck-choice__title">' + g[1] + '</span><span class="pck-choice__note pck-desktop-only">' + g[2] + '</span></button>';
      });
      h += '</div>';
    } else {
      h += '<p class="pck-note-box">' + esc(sty.name) + ' chips have no printed values. Pick the colors you want and set what each color is worth at your table.</p>';
    }
    h += '<div class="pck-choice-grid pck-choice-grid--sizes" role="radiogroup" aria-label="Set size">';
    SIZES.forEach(function (s) {
      var on = state.size === s.n;
      h += '<button type="button" role="radio" aria-checked="' + on + '" class="pck-choice pck-choice--stack" data-act="size" data-id="' + s.n + '" data-key="z-' + s.n + '"><span class="pck-choice__title pck-num">' + commas(s.n) + ' chips</span><span class="pck-choice__note">' + s.note + '</span></button>';
    });
    h += '</div></section>';

    // Step 3
    var valuesTitle = sty.denom ? 'Set your values' : 'Pick your colors';
    var mixNote = (sty.denom ? 'Suggested for a ' + (state.game === 'cash' ? 'cash game' : 'tournament') + ' with ' : 'Suggested colors for ') +
      SIZE_PHRASE[state.size] + '. Each press adds or removes one roll of 25.' +
      (anyOut ? ' Sold-out ' + valuesWord + ' are skipped.' : '');
    h += '<section class="pck-bstep" aria-labelledby="bs3">' + stepHead(3, valuesTitle,
      '<div class="pck-step-head__row"><h2 id="bs3" class="pck-step-head__h2">' + valuesTitle + '</h2><button type="button" class="pck-quiet" data-act="reset" data-key="reset">Reset to suggested mix</button></div>');
    h += '<p class="pck-step-note">' + esc(mixNote) + '</p>';
    h += '<div class="pck-bvalues">';
    sty.vals.forEach(function (v) {
      var n = state.counts[v.id] || 0;
      var rollsText = n === 0 ? money(v.price) + ' per roll' : (n / 25) + (n === 25 ? ' roll' : ' rolls');
      h += '<div class="pck-bvalue' + (n === 0 ? ' is-zero' : '') + (v.out ? ' is-out' : '') + '">' +
        '<img class="pck-bvalue__chip" src="' + esc(v.img) + '" alt="' + esc(v.alt) + '" width="48" height="48" loading="lazy">' +
        '<div class="pck-bvalue__text"><div class="pck-bvalue__label pck-num">' + esc(v.label) + (v.color ? ' <span>· ' + esc(v.color) + '</span>' : '') + '</div>' +
        (v.out ? '<span class="pck-pill-out">Sold out</span>' : '<div class="pck-bvalue__rolls pck-num">' + rollsText + '</div>') + '</div>' +
        stepper('v' + v.id, commas(n), { act: 'val', id: v.id, noRemove: n === 0, noAdd: v.out, cls: 'pck-stepper--lg',
          addLabel: 'Add a roll of ' + v.label + ' chips', removeLabel: 'Remove a roll of ' + v.label + ' chips' }) +
        '</div>';
    });
    h += '</div>';
    h += '</section>';

    // Step 4
    var caseIntro = sty.is43 ? sty.name + ' chips are 43mm, so they fit only the oversized 43mm case.' : 'Cases that fit ' + commas(state.size) + ' chips.';
    h += '<section class="pck-bstep" aria-labelledby="bs4">' + stepHead(4, 'Pick a case').replace('<h2 ', '<h2 id="bs4" ').replace('</div>', '<p class="pck-step-note pck-desktop-only">' + esc(caseIntro) + '</p></div>');
    h += '<div class="pck-choice-grid pck-choice-grid--cases" role="radiogroup" aria-label="Case">';
    caseList.forEach(function (c) {
      var on = c.id === cs.id;
      h += '<button type="button" role="radio" aria-checked="' + on + '" class="pck-choice pck-choice--case" data-act="case" data-id="' + esc(c.id) + '" data-key="c-' + esc(c.id) + '"' + (c.out ? ' disabled' : '') + '>' +
        (c.img ? '<img src="' + esc(c.img) + '" alt="" width="96" height="80" loading="lazy">' : '<span class="pck-choice__none">No case</span>') +
        '<span class="pck-choice__text"><span class="pck-choice__title">' + esc(c.name) + '</span>' +
        '<span class="pck-choice__meta"><span class="pck-desktop-only">' + esc(c.meta) + '</span><span class="pck-mobile-only">' + esc(c.metaShort || c.meta) + '</span></span>' +
        '<span class="pck-choice__price pck-num">' + (c.out ? 'Sold out' : money(c.price)) + '</span></span></button>';
    });
    h += '</div>';
    h += fillViz(cs, chips, capacity, over, fillNote, 'pck-mobile-only');
    if (D.extras.length) {
      h += '<div class="pck-extras"><span class="pck-extras__title">Finish the table</span>';
      D.extras.forEach(function (e) {
        var q = state.extras[e.k] || 0;
        h += '<div class="pck-extra' + (q > 0 ? ' is-on' : '') + '" role="group" aria-label="' + esc(e.label) + '">' +
          '<img src="' + esc(e.img) + '" alt="" width="64" height="64" loading="lazy">' +
          '<span class="pck-extra__text"><span class="pck-extra__label"><span class="pck-desktop-only">' + esc(e.label) + '</span><span class="pck-mobile-only">' + esc(e.labelShort || e.label) + '</span></span>' +
          '<span class="pck-extra__note"><span class="pck-desktop-only">' + esc(e.note).replace('{price}', money(e.price)) + '</span><span class="pck-mobile-only">' + esc(e.noteShort || e.note).replace('{price}', money(e.price)) + '</span></span></span>' +
          stepper('x' + e.k, q, { act: 'extra', id: e.k, noRemove: q <= 0, noAdd: q >= 10 || e.out, cls: 'pck-stepper--sm', addLabel: 'Add a ' + e.unit, removeLabel: 'Remove a ' + e.unit }) +
          '<span class="pck-extra__price pck-num pck-desktop-only">' + money(q > 0 ? q * e.price : e.price) + '</span></div>';
      });
      h += '</div>';
    }
    h += '</section></div>';

    // Summary (desktop)
    h += '<aside class="pck-bsum" aria-label="Your set">';
    h += '<div class="pck-bsum__head"><img src="' + esc(sty.img) + '" alt="" width="72" height="72">' +
      '<div class="pck-bsum__titles"><span class="pck-eyebrow">Your set</span><span class="pck-bsum__name">' + esc(sty.name) + ' · ' + commas(chips) + ' chips</span>' +
      '<span class="pck-bsum__sub">' + (sty.denom ? (state.game === 'cash' ? 'Cash game' : 'Tournament') : 'Non-denominated') + ' · ' + valuesUsed + ' ' + (valuesUsed === 1 ? valuesWord.slice(0, -1) : valuesWord) + '</span></div></div>';
    h += fillViz(cs, chips, capacity, over, fillNote, '');
    h += '<ul class="pck-bsum__lines">';
    h += '<li><span>' + rolls + (rolls === 1 ? ' roll' : ' rolls') + ' at ' + money(sty.price) + '</span><span>' + money(chipCents) + '</span></li>';
    h += '<li><span>' + esc(cs.name) + '</span><span>' + money(cs.price) + '</span></li>';
    extraLines.forEach(function (x) { h += '<li><span>' + esc(x.label) + '</span><span>' + money(x.cents) + '</span></li>'; });
    h += '</ul>';
    h += '<div class="pck-bsum__total"><span>Set total</span><strong class="pck-num">' + money(total) + '</strong></div>';
    h += '<button type="button" class="pck-btn pck-btn--primary pck-btn--block pck-bsum__btn" data-act="add" data-key="add"' + (rolls === 0 || state.busy ? ' disabled' : '') + '>' + (state.busy ? 'Adding…' : (rolls === 0 ? 'Add at least one roll' : 'Add set to cart')) + '</button>';
    if (state.error) h += '<p class="pck-error" role="alert">' + esc(state.error) + '</p>';
    var parts = [valuesUsed + ' chip ' + (valuesUsed === 1 ? valuesWord.slice(0, -1) : valuesWord) + ' in rolls of 25'];
    if (cs.id !== 'none') parts.push('the case');
    if (extraLines.length) parts.push(extraLines.length === 1 ? 'the extra' : 'the extras');
    var list = parts.length > 1 ? parts.slice(0, -1).join(', ') + ' and ' + parts[parts.length - 1] : parts[0];
    h += '<p class="pck-bsum__items">Adds ' + items + (items === 1 ? ' item' : ' items') + ' to your cart: ' + list + '. Most orders ship within 2 business days.</p>';
    h += '</aside></div>';

    // Sticky bar (phones)
    h += '<div class="pck-sticky pck-mobile-only"><div class="pck-sticky__sum"><span class="pck-sticky__total pck-num">' + money(total) + '</span>' +
      '<span class="pck-sticky__sub">' + commas(chips) + ' chips · ' + esc(sty.name) + '</span></div>' +
      '<button type="button" class="pck-btn pck-btn--primary pck-sticky__btn" data-act="add" data-key="add-m"' + (rolls === 0 || state.busy ? ' disabled' : '') + '>' + (state.busy ? 'Adding…' : 'Add set to cart') + '</button></div>';

    paint(h);
  }

  function fillViz(cs, chips, capacity, over, note, cls) {
    if (!cs.rows) return '';
    var h = '<div class="pck-fill ' + cls + '"><div class="pck-fill__case" role="img" aria-label="' + commas(chips) + ' of ' + commas(capacity) + ' chips in the ' + esc(cs.name) + '" style="grid-template-columns: repeat(' + cs.rows + ', minmax(0, 1fr))">';
    for (var i = 0; i < cs.rows; i++) {
      var f = Math.max(0, Math.min(1, (chips - i * cs.per) / cs.per));
      h += '<span class="pck-fill__row"><span class="pck-fill__level' + (over ? ' is-over' : '') + '" style="height:' + Math.round(f * 100) + '%"></span></span>';
    }
    h += '</div><div class="pck-fill__text pck-num' + (over ? ' is-over' : '') + '"><span><b>' + commas(chips) + '</b> of ' + commas(capacity) + ' chips</span><span>' + esc(note) + '</span></div></div>';
    return h;
  }

  function addToCart() {
    var sty = findStyle(state.styleKey);
    if (!sty) return;
    var caseList = casesFor(sty, state.size);
    var cs = caseList.filter(function (c) { return c.id === state.caseId; })[0] || caseList[0];
    var chips = 0;
    sty.vals.forEach(function (v) { chips += state.counts[v.id] || 0; });
    var props = { _set: sty.name + ' set · ' + commas(chips) + ' chips', _set_style: sty.k, _set_size: String(state.size) };
    var items = [];
    sty.vals.forEach(function (v) {
      var n = state.counts[v.id] || 0;
      if (n > 0) items.push({ id: v.id, quantity: n / 25, properties: props });
    });
    if (!items.length) return;
    if (cs.id !== 'none') items.push({ id: cs.variant, quantity: 1, properties: props });
    D.extras.forEach(function (e) {
      var q = state.extras[e.k] || 0;
      if (q > 0) items.push({ id: e.variant, quantity: q, properties: props });
    });
    set({ busy: true, error: '' });
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Something went wrong.'); });
      window.location.href = root + 'cart';
    }).catch(function (err) {
      set({ busy: false, error: err.message + ' Please try again.' });
    });
  }

  app.addEventListener('click', function (e) {
    var b = e.target.closest('[data-act]');
    if (!b || b.disabled) return;
    var act = b.getAttribute('data-act'), id = b.getAttribute('data-id'), d = +b.getAttribute('data-d');
    var sty = findStyle(state.styleKey);
    switch (act) {
      case 'filter': set({ filter: id }); break;
      case 'style': {
        var s = findStyle(id);
        if (!sty) {
          // First pick: fill in the rest of the builder, then bring step 2 into view.
          set({ styleKey: s.k, counts: mix(s, state.game, state.size), caseId: startCaseFor(s, state.size) });
          var next = document.getElementById('bs2');
          if (next) next.closest('section').scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          break;
        }
        set({ styleKey: s.k, counts: mix(s, state.game, state.size), caseId: (s.is43 !== sty.is43 || !casesFor(s, state.size).some(function (c) { return c.id === state.caseId; })) ? defaultCase(s, state.size) : state.caseId });
        break;
      }
      case 'game': set({ game: id, counts: mix(sty, id, state.size) }); break;
      case 'size': set({ size: +id, counts: mix(sty, state.game, +id), caseId: defaultCase(sty, +id) }); break;
      case 'reset': set({ counts: mix(sty, state.game, state.size) }); break;
      case 'val': {
        var counts = Object.assign({}, state.counts);
        counts[id] = Math.max(0, (counts[id] || 0) + d * 25);
        set({ counts: counts });
        break;
      }
      case 'case': set({ caseId: id }); break;
      case 'extra': {
        var x = Object.assign({}, state.extras);
        x[id] = Math.max(0, Math.min(10, (x[id] || 0) + d));
        set({ extras: x });
        break;
      }
      case 'add': addToCart(); break;
    }
  });

  render();
})();
